module.exports = __webpack_public_path__ + "static/media/B_F01.382df340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/B_F01.png
// module id = 89
// module chunks = 0